/**
 * ¿La URL actual cae dentro de `link`? Compara por segmentos: `/accounts/pending-accounts` cubre
 * `/accounts/pending-accounts/cc`, pero no `/accounts/pending-accounts-history`. Los links externos
 * (`https://…`) nunca quedan activos.
 */
export const matchesNavLink = (url: string, link: string): boolean => {
    if (!link.startsWith('/')) return false;
    const path = url.split(/[?#;]/)[0];
    return path === link || path.startsWith(`${link}/`);
};
